package com.taager.dukan.store.domain.entity

data class QuickLink(
    val id: String,
    val title: String,
    val headline: String,
    val content: String,
)
